var _defs, _defs2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMikaSad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 319.4 397.7",
    style: {
      enableBackground: "new 0 0 319.4 397.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1_00000000214379389530024980000016117982905198173362_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#D0E09C"
    },
    cx: 159.7,
    cy: 237.9,
    r: 159.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M319.4,237.9c0-88.2-71.5-259.7-159.7-259.7S0,149.7,0,237.9s71.5,159.7,159.7,159.7 S319.4,326.1,319.4,237.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000104706813287296980060000000755969615203641992_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000104706813287296980060000000755969615203641992_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001F47"
    },
    d: "M183.9,37.4c0.5-11.4-14.7-27.2-32.1-29.1c-45-4.9-70.4,32.7-80.4,80.1 C63,128.1,74.5,199.6,38,207.2c0,0,0,0.2-0.1,0.5c-1,11.3,16.3,12.1,26.2,6.6c25.3-13.9,32.3-51.4,32.3-51.4 s-11.7,68.3-52.7,75.2c0,0,11,16.9,39.6,22.2c112.6,20.9,84.3-123.4,84.3-123.4L183.9,37.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001F47"
    },
    d: "M217.5,192.2c4.8,10.8,13.2,36.4,29.3,47.4c16.1,11-41.4,14.7-41.4,14.7l-14.5-52l13.3-21.9 L217.5,192.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E7E8F3"
    },
    d: "M285.1,265.5c-5.6-9.8-27.5-20.6-30.3-20.9c-10.1-1-51.7-0.1-55.9-13.6 c-2.5-8-2.4-17.1-1.6-24.4h-54.5c1,6.6,0.8,13.3,0.7,20.1c-0.3,14-11,12.2-13.3,13c-9.1,3-31.3,5.8-45.8,7.4 c-7.9,0.9-29.1,11.1-37,22.8c-8.1,12-7.9,118.6-6.3,143.9h255C297.2,383.1,294.6,282,285.1,265.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CDCFE0"
    },
    d: "M50.6,266.3c-7.2,9.5-8.3,24.9-8.6,27.8c9.1,18.3,24.5,43.1,24.5,43.1c0.2,1,2.3,70.5,2.7,76.6 h9.3C80.7,362.8,50.6,266.3,50.6,266.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CDCFE0"
    },
    d: "M269.2,335.6c0,0,15.5-25,23.3-40.8c0,0-2.5-22.1-8.7-29c-1.4,2.4-30.5,111.5-26.8,148.1h10.8 C268.2,408,268,345.3,269.2,335.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1C2D50"
    },
    d: "M262.1,332.6c10.9-16.5,30.4-51,30.4-51s-10.2-38.4-50.7-39.8c-19.3,15.5-60.5,21.9-76.9,21.8 c-25.2-0.1-53.5-9.3-65.9-20.2c-27.8,2.9-49.8,17.7-57.9,38.2c9.7,19.8,27.8,40.4,32.2,52.3c2.7,15.9,1.4,74.9,1.4,79.9h186.5 C260.9,402.3,260.4,349.9,262.1,332.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001F47"
    },
    d: "M86.1,413.9H74.6c0,0-1.6-95.4-2.8-102.3L86.1,413.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001F47"
    },
    d: "M249.6,413.9h11.5c0,0,1.1-96.6,1.8-103.3L249.6,413.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E7E8F3"
    },
    d: "M231.3,244.2c2.2-0.9,4.4-2.2,6.6-3.5c-24.7-3.2-32.1-7.4-33.9-8.6c-1.9-1.3-3.7-7.4-4.4-14.6 c-0.3-3.1-0.8-15-0.9-19.1c-0.9,1.1-55,3.1-57,0l-6.3,0c0,0,1.9,19.9-1.1,34.2c-0.6,2.9-18.1,7-29.6,9.4 c0.8,0.6,3.8,2.6,4.4,3c9.8,1,18.3,2.1,22.3,1.4c4.9-0.9,13.2-4.6,19.2-7.4c32.4-14.9,42.6-19.8,42.6-19.8 c1.5,13.8,11.7,23,11.2,22.8C212.5,244.1,222.5,244.5,231.3,244.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CDCFE0"
    },
    d: "M180,256.4c0,0,3.3-8.4,7.8-9.6c4.5-1.1,46.3-1.4,52.2-2.6c0,0-13.9,3.5-26.8,5 C200.3,250.7,190.2,248.5,180,256.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CDCFE0"
    },
    d: "M164,256.3c0,0-3.1-6.5-8.7-8.4c-5.6-1.9-48.3-4.5-56-3.8C99.3,244.2,153.2,249.6,164,256.3z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#475C90"
    },
    d: "M109.2,240.9c0,0,24.8,18,59.8,18.6c31.5,0.5,52.9-6.5,65.5-19.5l8.6,1.7 c0,0-17.2,27.6-73.2,26.2c-48.1-1.2-71.3-24.6-71.3-24.6L109.2,240.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000068658018899545411900000009154489980315276721_",
    gradientUnits: "userSpaceOnUse",
    x1: 169.5426,
    y1: 166.2521,
    x2: 154.0762,
    y2: -24.1763,
    gradientTransform: "matrix(1 0 0 -1 0 402.8144)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#001F47",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1228,
    style: {
      stopColor: "#00224B",
      stopOpacity: 0.1228
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3147,
    style: {
      stopColor: "#052B57",
      stopOpacity: 0.3147
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5518,
    style: {
      stopColor: "#153866",
      stopOpacity: 0.5518
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8222,
    style: {
      stopColor: "#2B4A78",
      stopOpacity: 0.8222
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3B5683"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "url(#SVGID_00000068658018899545411900000009154489980315276721_)",
      enableBackground: "new"
    },
    d: " M95.8,403.8c16.5,3.7,136.8,5.7,144.2,2c7.4-3.7,13.8-127.8,13.8-127.8H77.6C77.6,277.9,85.9,401.6,95.8,403.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001F47"
    },
    d: "M226.6,169.5c5,15.9,9.7,37.1,22.6,44.5c0,0-8.9,7.4-20.9-1c-11.9-8.4-19.7-24.9-22-36.3 C204.1,165.3,226.6,169.5,226.6,169.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001F47"
    },
    d: "M237.5,105.7c11.4,24.1-12.1,44.3-1.3,94.1c4.3,19.9-26.9-33.5-26.9-33.5l17.3-69.8L237.5,105.7 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B8B9D6"
    },
    d: "M211.8,146.2c0,0,10.1-16.8,19.6-13.9c22.8,6.9,0.6,39.2-13.1,40.2c-4.4,0.3-6.9-3.4-6.9-3.4 L211.8,146.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7E87B1"
    },
    d: "M218.5,149.1c5.4-6.2,11.1-4.3,11.5,0.5c0.6,6.2-10.5,18.3-17.2,12.1L218.5,149.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E8F3"
    },
    d: "M229.2,137.4c4.4-1,10.1,1.6,11.8,4.8c-0.7-4.4-3.3-9.1-9.9-10.4c-9.7-2-19.3,14.5-19.3,14.5 l-0.4,17.1C214.3,155.6,220.3,139.5,229.2,137.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E8F3"
    },
    d: "M218.2,172.5c5.6-0.4,12.6-6,17.4-12.9c-10,14.1-21.3,6.8-24.3,3.7l-1.9,5.2 C209.5,168.5,213.8,172.8,218.2,172.5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E8F3"
    },
    d: "M141.8,187c4.2,35.5-2,45.5-2,45.5s-6.9,6.3,22.1,11.4c35.4,6.2,33.8-4.9,33.8-4.9 s-0.7-24.9,2.7-40.6C201.8,182.8,141.8,187,141.8,187"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9B9D6"
    },
    d: "M141.8,187c0.4,3.4-10.5-3-10.4,0.2l11.7,20.5c19.4,33.5,52.5,22.1,52.5,22.1l1.9-26.8 c0.2-1.5,0.5-3,0.8-4.5C201.8,182.8,141.8,187,141.8,187"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001F47"
    },
    d: "M151.1,0.9c0,0,0.7,0.3,2,0.8c1.3,0.5,3.1,1.2,5.3,2.2c2.2,1,4.7,2.2,7.4,3.7 c1.3,0.8,2.7,1.6,4,2.5s2.6,2,3.9,3c0.6,0.6,1.3,1.1,1.9,1.7l0.9,0.9c0.3,0.3,0.6,0.6,0.9,0.9c0.6,0.6,1.1,1.3,1.6,1.9 c0.5,0.7,1,1.3,1.5,2c0.9,1.4,1.7,2.7,2.4,4.1c0.3,0.7,0.7,1.3,0.9,2c0.3,0.7,0.6,1.3,0.8,1.9c0.2,0.6,0.4,1.2,0.6,1.8 c0.2,0.6,0.3,1.2,0.5,1.7c0.3,1.1,0.4,2,0.6,2.8c0.2,1.6,0.3,2.5,0.3,2.5c0.4,2.7-1.5,5.2-4.2,5.5c-2.7,0.4-5.2-1.5-5.5-4.2 c0-0.3-0.1-0.6,0-0.9v-0.2c0,0,0-0.7,0.1-1.9c0-0.6,0-1.3,0-2.1c0-0.4-0.1-0.9-0.1-1.3c0-0.5-0.1-0.9-0.2-1.5 c-0.1-0.5-0.2-1-0.3-1.6c-0.1-0.6-0.3-1.1-0.4-1.7c-0.3-1.2-0.8-2.4-1.3-3.6c-0.3-0.6-0.6-1.2-0.9-1.8c-0.3-0.6-0.7-1.2-1-1.8 c-0.2-0.3-0.4-0.6-0.6-0.9l-0.6-0.9c-0.4-0.6-0.9-1.2-1.3-1.8c-0.9-1.2-1.9-2.3-3-3.4c-1-1.1-2.1-2.1-3.2-3 c-2.2-1.9-4.4-3.5-6.3-4.9c-1.9-1.3-3.6-2.4-4.8-3.1C151.7,1.4,151.1,0.9,151.1,0.9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001F47"
    },
    d: "M180.9,8c0,0,0.3,0.4,0.7,1.1c0.5,0.7,1.1,1.8,1.8,3.1c0.4,0.7,0.7,1.4,1.1,2.2 c0.3,0.8,0.7,1.6,1.1,2.5c0.2,0.4,0.4,0.9,0.5,1.3c0.2,0.5,0.3,0.9,0.5,1.4c0.3,0.9,0.6,1.9,0.9,2.9c0.2,1,0.5,2,0.7,2.9 c0.2,1,0.4,2,0.5,2.9c0.1,0.5,0.1,0.9,0.2,1.4s0.1,0.9,0.1,1.4c0.1,0.9,0.1,1.7,0.1,2.5s0,1.5,0,2.1s-0.1,1.2-0.1,1.6 c-0.1,0.9-0.1,1.4-0.1,1.4c-0.1,1.4-1.3,2.5-2.7,2.4c-1.4-0.1-2.5-1.3-2.4-2.7c0-0.1,0-0.3,0.1-0.4v-0.2c0,0,0.1-0.5,0.3-1.2 c0.1-0.4,0.2-0.9,0.3-1.4c0.1-0.6,0.2-1.2,0.3-1.9c0.1-0.7,0.2-1.5,0.2-2.3c0-0.4,0.1-0.8,0.1-1.2c0-0.4,0-0.9,0-1.3 c0-0.9,0-1.8,0-2.7c0-0.9-0.1-1.9-0.2-2.8s-0.2-1.9-0.4-2.8c-0.1-0.5-0.2-0.9-0.2-1.4c-0.1-0.5-0.2-0.9-0.3-1.4 c-0.2-0.9-0.4-1.7-0.6-2.5s-0.5-1.6-0.7-2.3c-0.5-1.4-0.9-2.5-1.3-3.3C181.1,8.5,180.9,8,180.9,8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B8B9D6"
    },
    d: "M125.5,149.8c0,0-8.4-17.1-17.9-15c-22.6,4.9-3.7,38,9.5,39.9c4.2,0.6,7-2.7,7-2.7L125.5,149.8z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7E87B1"
    },
    d: "M119.5,145c-4.8-6.6-10.7-5.2-11.5-0.4c-1.1,6.1,9,19.1,16.2,13.5L119.5,145z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E8F3"
    },
    d: "M109.3,139.9c-4.2-1.4-9.9,0.7-11.8,3.7c1-4.2,4-8.5,10.4-9.3c9.6-1.2,17.6,15.6,17.6,15.6 l-0.9,16.5C122.2,158.7,117.8,142.6,109.3,139.9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E8F3"
    },
    d: "M117.1,174.7c-5.4-0.8-11.7-6.8-15.8-13.9c8.6,14.4,20.1,8.3,23.2,5.6l1.4,5.2 C125.9,171.6,121.4,175.4,117.1,174.7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B8B9D6"
    },
    d: "M154.4,49.3c0.4-9.1,13.7-17,24.4-14.8c10.7,2.2,15.7,11.4,15.4,18.1 C193.8,59.3,154.4,49.3,154.4,49.3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E8F3"
    },
    d: "M120,176.6c4.6,18.1,15.8,22.9,24,32c7.8,8.7,15,12.6,24.3,12.2c11.3-0.5,14.9-3.2,21.3-10.8 c14.7-17.5,27.1-30.7,31.2-40.2c13.5-31.5,37.9-120.4-54.4-121.2C85.1,48,114.1,153.1,120,176.6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#B9B9D6",
      enableBackground: "new"
    },
    d: "M219.6,82.7c-13.1,22.5-51.3,55.4-109.1,53l29.8-78.8 L219.6,82.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001F47"
    },
    d: "M211.3,77.1c0,0-0.1,0.3-0.2,0.8c-0.1,0.4-0.3,1.1-0.4,1.4c-0.1,0.2-0.1,0.4-0.2,0.6 c-0.1,0.2-0.2,0.4-0.3,0.6c-0.4,0.9-0.8,1.8-1.4,2.9c-0.6,1-1.2,2.2-2,3.4c-3,4.9-7.3,11-12.5,16.3c-1.3,1.4-2.7,2.6-4,3.9 c-0.7,0.6-1.4,1.2-2.1,1.8c-0.7,0.5-1.4,1.1-2.1,1.6s-1.4,1-2.1,1.5c-0.4,0.2-0.7,0.5-1,0.7s-0.7,0.4-1,0.6 c-0.3,0.2-0.7,0.4-1,0.6c-0.3,0.2-0.7,0.3-1,0.5s-0.7,0.3-1,0.5c-0.3,0.1-0.7,0.3-1,0.4c-0.3,0.1-0.6,0.3-0.9,0.4 c-0.3,0.1-0.6,0.2-0.9,0.3s-0.6,0.2-0.9,0.3s-0.6,0.2-0.8,0.2c-0.5,0.1-1,0.3-1.5,0.4c-0.5,0.1-0.9,0.2-1.3,0.2 c-0.4,0.1-0.7,0.1-1.1,0.1c-0.3,0-0.6,0.1-0.8,0.1c-0.4,0-0.6,0.1-0.6,0.1s0.2-0.1,0.6-0.2c0.2-0.1,0.5-0.1,0.7-0.2 c0.3-0.1,0.6-0.2,1-0.3s0.8-0.3,1.2-0.5c0.4-0.2,0.9-0.4,1.4-0.6c0.2-0.1,0.5-0.2,0.7-0.4c0.2-0.1,0.5-0.3,0.8-0.4 c0.3-0.2,0.5-0.3,0.8-0.5s0.5-0.4,0.8-0.5c0.3-0.2,0.6-0.4,0.8-0.6c0.3-0.2,0.6-0.4,0.8-0.6c0.3-0.2,0.6-0.4,0.9-0.7 c0.3-0.2,0.6-0.5,0.9-0.7s0.6-0.5,0.9-0.7c0.3-0.3,0.6-0.5,0.9-0.8c0.6-0.5,1.1-1.1,1.7-1.7c0.6-0.6,1.1-1.2,1.7-1.8 c0.5-0.7,1.1-1.3,1.6-2c1-1.4,2.1-2.8,3-4.2c3.9-5.8,6.9-12.2,8.7-17c0.5-1.2,0.8-2.3,1.1-3.3c0.3-1,0.5-1.8,0.7-2.4 c0-0.2,0.1-0.3,0.1-0.4c0-0.1,0-0.2,0.1-0.3c0.1-0.3,0-0.1,0-0.1l0,0v-0.1v-0.2c0-0.1,0-0.2,0-0.2v-0.2 c0.1-2.9,2.5-5.2,5.4-5.1c2.9,0.1,5.2,2.5,5.1,5.4C211.4,76.4,211.4,76.8,211.3,77.1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001F47"
    },
    d: "M231.8,133.9c7-38.7,3.6-85.5-64-86.9c-61.9-1.3-63.9,47.7-56.3,84.6 c13.8,14.8,78.2-31.4,88.1-56.3C224,93.5,230.6,126.4,231.8,133.9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001F47"
    },
    d: "M149.6,115c-8.7,14.2-22.6,27.5-53.3,22.5c6.9-7.6,9.5-21.9,10.1-35.2L149.6,115z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CFCFE5"
    },
    d: "M195.7,165.6c-2.7-0.1-2.9,4.1-0.2,4.2C198.2,169.9,198.4,165.7,195.7,165.6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CFCFE5"
    },
    d: "M190.9,156.8c-2.7-0.1-2.9,4.1-0.2,4.2C193.4,161.1,193.6,156.9,190.9,156.8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CFCFE5"
    },
    d: "M203.9,154.6c-2.7-0.1-2.9,4.1-0.2,4.2C206.5,158.9,206.6,154.7,203.9,154.6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CFCFE5"
    },
    d: "M143.8,169.3c-2.7-0.1-2.9,4.1-0.2,4.2C146.3,173.6,146.5,169.4,143.8,169.3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CFCFE5"
    },
    d: "M135.8,162.3c-2.7-0.1-2.9,4.1-0.2,4.2C138.3,166.6,138.5,162.4,135.8,162.3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CFCFE5"
    },
    d: "M127.9,153.3c-2.7-0.1-2.9,4.1-0.2,4.2C130.5,157.7,130.6,153.4,127.9,153.3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CFCFE5"
    },
    d: "M142.3,155.3c-2.7-0.1-2.9,4.1-0.2,4.2C144.8,159.6,145,155.4,142.3,155.3"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CFCFE5"
    },
    d: "M159.7,136.9c0,0,1.9,15.5,1.2,19.5c-0.1,0.6,0.5,1,0.5,1c0.1,0,1.9-11.1,1.9-11.1L159.7,136.9z "
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000028313719633436942270000007168347155617756863_",
    x: 80.2,
    y: 51.6,
    transform: "matrix(4.128690e-02 -0.9991 0.9991 4.128690e-02 29.532 187.974)",
    width: 65,
    height: 53.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000068668938530896997430000009340370540790039951_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000028313719633436942270000007168347155617756863_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000068668938530896997430000009340370540790039951_)",
      fill: "#475C90"
    },
    d: "M128.9,55.8 c-9.6,8.8-26.4,23.5-32.2,53.3c0,0-2.4-16.3,9.9-34.2C114.7,62.9,128.9,55.8,128.9,55.8"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001F47"
    },
    d: "M220.6,66.7c9,11.6,19.5,52.4,36.1,59.9c0,0-19-1.3-28.2-35C221.6,65.9,220.6,66.7,220.6,66.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001F47"
    },
    d: "M207.9,56.2c21.3,9.6,32.1,47,45.5,50.9c0,0-14.3,1.4-25.6-24.4C219.1,63,207.9,56.2,207.9,56.2 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001F47"
    },
    d: "M95,33.4c-13,16.7-20.6,40-28.3,89.1s-31.2,44-37.4,44.8c0,0,25.8,10.3,41.6-22 s31.9-98.5,31.9-98.5L95,33.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#7E87B1",
      enableBackground: "new"
    },
    d: "M172.1,170.9c2.1-0.8,5.8-2.1,6.1-0.4 c0.2,1.4-3.3,0.9-4.8,1.3C171.8,172.3,172.1,170.9,172.1,170.9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B8B9D6"
    },
    d: "M179,166c0.6,1.3,1.3,5.6-1.4,6.5c0,0,2.3-0.1,2.8-2.8C181,166.9,179,166,179,166"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#7E87B1",
      enableBackground: "new"
    },
    d: "M163.5,171.2c-2.2-0.7-5.9-1.8-6.1,0 c-0.1,1.4,3.3,0.7,4.9,1C163.9,172.5,163.5,171.2,163.5,171.2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B8B9D6"
    },
    d: "M156.3,166.7c-0.5,1.4-1,5.7,1.8,6.4c0,0-2.3,0.1-3-2.6C154.4,167.7,156.3,166.7,156.3,166.7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#C6C8DE",
      enableBackground: "new"
    },
    d: "M163.7,172.1c0,0,1,2.1,4.2,2.1c0.1,0,0.1,0,0.2,0 c3.3-0.1,3.7-1.9,3.7-1.9c-0.9,0.6-2.2,0.8-3.5,0.8C166.6,173.1,165,172.8,163.7,172.1"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#CDCFE0",
      enableBackground: "new"
    },
    d: "M158.1,173.1c5.9,2.8,8.1,7.2,13.9,4.1s6.2-4.8,6.2-4.8 s-3.2-0.2-6.2,0.3c-1.6,0.3-3,1.5-4.1,1.4c-1.2-0.1-2-1.8-3.7-1.3C160.9,174.1,158.1,173.1,158.1,173.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ADB1CF"
    },
    d: "M194.5,128.1c-8.4-0.3-13.6,5.8-16.6,9.7c3-3,9.1-7.9,13.3-8.2c0.3,0,0.7,0,1,0 c2,0.1,4.4,0.7,6.9,1.4s5,1.3,7.2,1.4c0.1,0,0.1,0,0.2,0C201.8,129.5,197.9,128.2,194.5,128.1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001F47"
    },
    d: "M176.5,139.2c2.1-2.5,9.7-9.2,14.6-9.6c2.1-0.2,4.9,0.6,7.9,1.4c4,1.1,8.1,2.1,10.7,0.8 c0,0-2.4,5-5.5,5.2c-1.6,0.1-4.4-0.5-7-1.1c-2.5-0.6-4.7-1.1-5.6-1.1c-2.3,0.2-7.2,0.9-11,2.9 C178,139,176.5,139.2,176.5,139.2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CFCFE5"
    },
    d: "M187,137.7h-0.1c-2,0.1-10.9,2.6-10.9,2.6l3.6,0.3l-2.2-0.6h5.4 C184.9,139.2,188,137.7,187,137.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CFCFE5"
    },
    points: "193,140.1 182.8,140.1 177.4,140 179.6,140.6 184.1,141.8  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B7BBD4"
    },
    d: "M209.6,135.1c0,0-1.8,0.7-4,1.4c-0.5,0.3-1,0.4-1.5,0.5H204c-1.2,0.3-2.4,0.6-3.5,0.7 c-1.1,0.1-1.1,0.2-0.6,0.2c1.2,0.1,6-0.2,6-0.2L209.6,135.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4A5A89"
    },
    d: "M205.6,136.5c-0.5,0.2-1.1,0.3-1.6,0.5h0.1C204.6,136.9,205.1,136.7,205.6,136.5"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#001F47"
    },
    points: "176.1,138.6 183.2,130.3 177.9,134.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ADB1CF"
    },
    d: "M139.1,128.9c8.4-0.3,13.6,5.8,16.6,9.7c-3-3-9.1-7.9-13.3-8.2c-0.3,0-0.7,0-1,0 c-2,0.1-4.4,0.7-6.9,1.4s-5,1.3-7.2,1.4c-0.1,0-0.1,0-0.2,0C131.8,130.2,135.7,129,139.1,128.9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001F47"
    },
    d: "M157.1,140c-2.1-2.5-9.7-9.2-14.6-9.6c-2.1-0.2-4.9,0.6-7.9,1.4c-4,1.1-8.1,2.1-10.7,0.8 c0,0,2.4,5,5.5,5.2c1.6,0.1,4.4-0.5,7-1.1c2.5-0.6,4.7-1.1,5.6-1.1c2.3,0.2,7.2,0.9,11,2.9C155.6,139.7,157.1,140,157.1,140"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CFCFE5"
    },
    d: "M146.6,138.5h0.1c2,0.1,10.9,2.6,10.9,2.6l-3.6,0.3l2.2-0.6h-5.4 C148.7,139.9,145.5,138.5,146.6,138.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CFCFE5"
    },
    points: "140.6,140.9 150.8,140.8 156.2,140.8 154,141.4 149.5,142.6  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B7BBD4"
    },
    d: "M123.9,135.8c0,0,1.8,0.7,4,1.4c0.5,0.3,1,0.4,1.5,0.5h0.1c1.2,0.3,2.4,0.6,3.5,0.7 c1.1,0.1,1.1,0.2,0.6,0.2c-1.2,0.1-6-0.2-6-0.2L123.9,135.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4A5A89"
    },
    d: "M128,137.2c0.5,0.2,1.1,0.3,1.6,0.5h-0.1C128.9,137.7,128.4,137.5,128,137.2"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#001F47"
    },
    points: "157.5,139.4 150.4,131.1 155.7,135.1  "
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001F47"
    },
    d: "M185.1,110.3c3.9,0,15.5,2.5,20,5.5c5.7,3.9,10.9,11.1,10.9,11.1s-5.4-5.1-13.2-7.2 c-6.5-1.8-19.8-3.9-19.8-3.9s-1.5-0.9,0.2-5.2c0,0-0.5,2.2,0.2,4c-0.1-1,0.3-3.4,0.8-4.2c-0.1,1.1,0.3,3,0.4,3.4 C184.2,111.6,185.1,110.3,185.1,110.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001F47"
    },
    d: "M187.9,189.1c0,0,2.6,0.8,2.5,1.5c0,0.4-0.6,0-2.1-0.4c-1-0.3-2.3-0.6-2.3-0.6 c0-0.1-6.6,0-7.3-0.2c-0.7-0.4-8.1,0.2-10.7,0.3c-2.6-0.1-12.3,0.2-13.7,0.4c-1.4,0-2.7,0.2-3.9,0.4 c-0.7,0.1-1.3,0.4-1.9,0.6c-0.6,0.2-2.4,1-2.8,0.5c-0.2-0.3-0.1-0.3,1.7-1.1c6.6-3.3,17.6-4.1,19.1-4.5 C168.1,185.1,184.3,187.3,187.9,189.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#475C90"
    },
    d: "M149.9,189.5c2.3-1.1,9.4-4.4,10.8-4.9c3.9-1.7,10.8-1.3,13.5-0.3c1.9,0.7,6.3,2.1,12.5,4.4 c-5.4-1.4-7.4-0.7-10.1-0.9c-0.8-0.1-4.2-1-9-0.9c-3.9,0.1-5.5,1.1-9.1,1.3C156.1,188.3,152.8,188.5,149.9,189.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#475C90"
    },
    d: "M150.4,190.5c2.3-0.7,4.6-1.2,7-1.7c0-0.1,7.9-1.3,10.8-1.2c2.2-0.1,10.1,0.7,11,0.8 c3.2-0.2,7,1.2,7,1.2s-2.7,0.2-5.3,1.6c-3.3,1.7-6.7,2.2-12.1,2.3c-7.1,0.1-9.2,0.1-12.4-1.5 C153.9,190.8,150.4,190.5,150.4,190.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#6D7DAE",
      enableBackground: "new"
    },
    d: "M156.7,190.1c2.1-2,10.9-1.9,11.6-1.8 c0.7-0.2,12.8,0.5,11.2,2.5c-1.5,1.7-6.2,1.7-9.3,1.8C161,192.9,154.6,192.1,156.7,190.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#6D7DAE",
      enableBackground: "new"
    },
    d: "M157.1,187.2c-0.9-0.2,3.5-2.3,5.4-2.8 c2.9-0.9,7.5-1.2,10.8-0.1c0.9,0.2,6.9,2.2,5.9,2.7c-1.7,0.8-8.9-1.6-13.2-1C163.7,186.2,159.8,187.7,157.1,187.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#7E87B1",
      enableBackground: "new"
    },
    d: "M177.5,189.7c0.1,0.4-0.8,1.6-2.9,2.2 c-2.6,0.8-4.7,0.2-4.9-0.2c-0.2-0.4,3.3-0.8,4.4-1.2C175.1,190.2,177.4,189.3,177.5,189.7z"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000021808184120331185700000000178469243209577141_",
    style: {
      opacity: 0.8,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: " M182.8,139.5c-0.6,1.2-2,1.8-3.2,1.2s-1.7-2.1-1.2-3.3c0.6-1.3,2-1.8,3.2-1.2C182.9,136.7,183.4,138.2,182.8,139.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000086649284129706246880000006593692181311433135_",
    style: {
      opacity: 0.8,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: " M154.4,139.7c-0.6,1.2-2,1.8-3.2,1.2c-1.2-0.6-1.7-2.1-1.2-3.3c0.6-1.3,2-1.8,3.2-1.2C154.4,136.9,155,138.4,154.4,139.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000118368645600607454120000000602032341031326864_",
    style: {
      opacity: 0.8,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: " M181.8,146.5c-0.4,0.9-1.4,1.2-2.3,0.8s-1.2-1.5-0.8-2.3c0.4-0.9,1.4-1.2,2.3-0.8C181.8,144.6,182.2,145.6,181.8,146.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000065782066674321575870000002973786647674673820_",
    style: {
      opacity: 0.8,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: " M153.8,145.1c-0.4,0.9-1.4,1.2-2.3,0.8s-1.2-1.5-0.8-2.3c0.4-0.9,1.4-1.2,2.3-0.8C153.9,143.2,154.2,144.2,153.8,145.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001F47"
    },
    d: "M201.4,78.3c0,0-0.2,0.6-0.6,1.7c-0.2,0.5-0.5,1.4-1,2.4c-0.4,1.1-0.9,2-1.5,3.2 c-1.2,2.3-2.7,4.9-4.8,7.7c-2,2.8-4.5,5.7-7.4,8.6c-2.9,2.9-6.2,5.7-9.8,8.5c-3.6,2.8-7.5,5.4-11.5,8 c-8.1,5.2-16.9,10-25.7,14.9c-4.4,2.4-8.7,4.9-12.9,7.4c-4.2,2.5-8.2,5.1-11.9,7.7c-1.9,1.3-3.7,2.7-5.3,4.1 c-0.9,0.7-1.7,1.4-2.5,2.1c-0.8,0.7-1.6,1.4-2.3,2.2c-2.9,2.9-5.3,6.1-7,9.3c-0.2,0.4-0.4,0.8-0.6,1.2 c-0.2,0.4-0.3,0.8-0.5,1.2c-0.4,0.8-0.6,1.6-0.9,2.4c-0.1,0.4-0.2,0.8-0.3,1.2s-0.2,0.8-0.3,1.2c-0.1,0.8-0.3,1.5-0.4,2.3 c-0.4,2.9-0.1,5.6,0.2,7.7c0.2,1.1,0.4,2,0.6,2.8c0.2,0.8,0.4,1.5,0.6,2.1c0.4,1.1,0.6,1.7,0.6,1.7s-0.3-0.6-0.7-1.6 c-0.3-0.5-0.5-1.2-0.8-2s-0.6-1.7-0.9-2.8c-0.5-2.1-1-4.8-1-8c0-0.8,0.1-1.6,0.1-2.4c0-0.4,0.1-0.8,0.2-1.3 c0.1-0.4,0.1-0.9,0.2-1.3c0.2-0.9,0.4-1.8,0.7-2.6c0.1-0.4,0.3-0.9,0.4-1.3c0.2-0.4,0.3-0.9,0.5-1.4c1.5-3.6,3.7-7.3,6.5-10.7 c0.7-0.9,1.4-1.7,2.2-2.6c0.8-0.8,1.5-1.7,2.4-2.5c1.6-1.7,3.3-3.3,5.1-4.9c3.6-3.2,7.5-6.2,11.5-9.2s5.6-10.1,9.7-13 c8.2-5.7,16.4-11.4,23.6-17.1c3.6-2.8,9.5-1.5,12.4-4.3c3-2.8,5.6-5.6,7.7-8.2c2.2-2.6,3.9-5.2,5.2-7.5c1.3-2.3,2.2-4.3,2.9-6 c0.3-0.8,0.6-1.6,0.8-2.2c0.2-0.6,0.3-1,0.5-1.7c0.3-1.1,0.4-1.7,0.4-1.7c1.1-4.3,5.5-7,9.8-5.9s7,5.5,5.9,9.8 C201.5,77.8,201.4,78,201.4,78.3"
  })))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2_00000056414575908667320440000013073112954806191503_"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMikaSad);
export default __webpack_public_path__ + "static/media/mika-sad.b61b0d706c9529dd09cb5c2413227314.svg";
export { ForwardRef as ReactComponent };